import { MdOutlineDeleteOutline } from 'react-icons/md'

import { Button } from '~/components/Buttons'
import ThumbVideoZoomable from '~/components/ThumbVideoZoomable'
import { formatDuration } from '~/helpers'
import i18n from '~/i18n'

const handleDeleteBanner = (data: DataModalHandle) => {
  data.handleDeleteBanner(data)
}
export const schemaVideo: TableSchema<DataModalHandle> = {
  media: {
    title: i18n.t('rm:campaign.create.Banner.table.media.title'),
    render: rowData => <ThumbVideoZoomable url={rowData?.media_url} />
  },
  fileName: {
    title: i18n.t('rm:campaign.create.Banner.table.fileName.title'),
    render: rowData => rowData?.fileMedia?.name
  },
  size: {
    title: i18n.t('rm:campaign.create.Banner.table.size.title'),
    render: rowData => (
      <div style={{ lineHeight: 1 }}>
        <strong className="title">
          <code>
            {rowData?.dimensions?.width} x {rowData?.dimensions?.height}
          </code>
        </strong>
      </div>
    ),
    className: 'order__details col__infos col__title'
  },
  duration: {
    title: i18n.t('rm:duration'),
    render: rowData => formatDuration(rowData?.dimensions?.duration)
  },
  actions: {
    render: rowData => (
      <div style={{ textAlign: 'right' }}>
        <Button
          onClick={() => handleDeleteBanner(rowData)}
          template="transparentCritical"
          size="xsmall"
          iconLeft={<MdOutlineDeleteOutline />}
          text={i18n.t('rm:campaign.create.Banner.table.actions.removeVideo')}
        />
      </div>
    )
  }
}
